import { useState, useEffect } from "@wordpress/element";
import { IconButton } from "./icon-button";
import { PlusIcon, MinusIcon } from "../icons";
import cx from "classnames";

export function Stepper( props: {
	variant?: "primary" | "secondary" | "white" | "transparent",
	value?: number,
	onChange?: ( num: number ) => void
} ) {
	const [ num, setNum ] = useState( 0 );

	useEffect( () => {
		if ( props.value !== undefined ) {
			setNum( props.value );
		}
	}, [ props.value ] );

	const onChange = ( val: number ) => {
		setNum( val );
		if ( props.onChange ) {
			props.onChange( val );
		}
	};

	const css = "text-sm w-7 h-7";

	return (
		<div className="flex flex-row items-center gap-x-2">
			{ num == 0
				? <IconButton size="none" icon={ <MinusIcon /> } className={ cx( css, "cursor-default" ) } />
				: <IconButton size="none" variant={ props.variant } icon={ <MinusIcon /> } className={ cx( css ) } onClick={ () => onChange( num - 1 ) } />
			}
			<span className="w-5 text-center">{ num }</span>
			<IconButton size="none" variant={ props.variant } className={ cx( css ) } icon={ <PlusIcon /> } onClick={ () => onChange( num + 1 ) } />
		</div>
	)
}
